var _defs, _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPickUpIconConstrained = function SvgPickUpIconConstrained(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Pick_UP_icon_constrained_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 500 500"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Pick_UP_icon_constrained_svg__cls-1{fill:#a0ce66}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M468.09 21.32a10.6 10.6 0 0 1 10.59 10.59v436.18a10.6 10.6 0 0 1-10.59 10.59H31.91a10.6 10.6 0 0 1-10.59-10.59V31.91a10.6 10.6 0 0 1 10.59-10.59zm0-20H31.91A30.58 30.58 0 0 0 1.32 31.91v436.18a30.58 30.58 0 0 0 30.59 30.59h436.18a30.58 30.58 0 0 0 30.59-30.59V31.91a30.58 30.58 0 0 0-30.59-30.59",
    className: "Pick_UP_icon_constrained_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.83 128.82 342.67 322H157.33l16.84-193.16h151.66m0-11H174.17a11 11 0 0 0-10.93 10L146.4 321a11 11 0 0 0 10.93 12h185.34a11 11 0 0 0 10.93-12l-16.84-193.13a11 11 0 0 0-10.93-10Z",
    className: "Pick_UP_icon_constrained_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.62 315.31h-22.23a5.49 5.49 0 0 1-5.48-5.84l4.87-75.73a5.49 5.49 0 0 1 10.95.7l-4.49 69.9h16.38a5.49 5.49 0 1 1 0 11Z",
    style: {
      fill: "#ed1c24"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M284.07 146.08a5.48 5.48 0 0 1-5.48-5.49v-29.46a28.59 28.59 0 0 0-57.18 0v28.25a5.49 5.49 0 1 1-11 0v-28.25a39.56 39.56 0 0 1 79.12 0v29.46a5.49 5.49 0 0 1-5.46 5.49",
    className: "Pick_UP_icon_constrained_svg__cls-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 216.3,
    cy: 139.38,
    r: 9.91,
    className: "Pick_UP_icon_constrained_svg__cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.31,
    cy: 139.38,
    r: 9.91,
    className: "Pick_UP_icon_constrained_svg__cls-1"
  })));
};
export default SvgPickUpIconConstrained;